import React from "react";
import Layout from "components/Layout";
import "styles/legal.css";

const DatenschutzPage = () => {
  return (
    <Layout>
      <section className="legal-page">
        <div className="legal-shell">
          <h1>Datenschutzerklärung</h1>

          <p className="legal-meta">
            Stand: Mai 2026. Diese Datenschutzerklärung gilt für die Website
            mediconsult.group sowie alle damit verbundenen Buchungs- und
            Kundenkonten der MediConsult Group.
          </p>

          <h2>Verantwortliche Stelle</h2>
          <p>
            MediConsult Group
            <br />
            Cremon 11
            <br />
            20457 Hamburg
            <br />
            Web:{" "}
            <a href="https://mediconsult.group" target="_blank" rel="noopener noreferrer">
              mediconsult.group
            </a>
          </p>

          <h2>Allgemeine Hinweise</h2>
          <p>
            Wir verarbeiten personenbezogene Daten nur, soweit dies für den Betrieb
            dieser Website, die Kommunikation mit Ihnen oder die Erbringung unserer
            Leistungen erforderlich ist. Rechtsgrundlage ist die
            Datenschutz-Grundverordnung (DSGVO), insbesondere Art. 6 Abs. 1
            lit. a, b und f DSGVO.
          </p>

          <h2>Online-Terminbuchung &amp; Kundenkonto</h2>
          <p>
            Für unser Buchungssystem und das Kundenkonto verarbeiten wir die von
            Ihnen angegebenen Daten (Vorname, Nachname, E-Mail, Telefonnummer,
            Passwort als Hash sowie Buchungsdaten inkl. Adresse für mobile
            Buchungen). Die Verarbeitung dient der Anlage und Verwaltung Ihres
            Kontos sowie der Durchführung der von Ihnen gebuchten Termine.
            Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO. Daten werden auf einem
            gemeinsamen System (MongoDB Atlas) gespeichert, das auch unsere
            Schwesterseiten betreibt.
          </p>

          <h2>Lizenzpartner-Erstbesuch (kostenfrei)</h2>
          <p>
            Wenn Sie ein kostenfreies Erstgespräch als Lizenzpartner anfragen,
            verarbeiten wir Ihre Kontakt- und Studio-Daten zur Vorbereitung des
            Vor-Ort-Termins. Rechtsgrundlage ist Art. 6 Abs. 1 lit. b DSGVO.
          </p>

          <h2>Zahlungsabwicklung (Stripe)</h2>
          <p>
            Für mobile Buchungen erfolgt die Zahlung über Stripe. Zahlungsdaten
            werden ausschließlich beim Zahlungsdienstleister verarbeitet; wir
            erhalten lediglich den Status der Transaktion.
          </p>

          <h2>E-Mail-Versand (Brevo)</h2>
          <p>
            Bestätigungen, Erinnerungen und Passwort-Resets werden über den
            E-Mail-Dienstleister Brevo (Sendinblue) versendet. Rechtsgrundlage ist
            Art. 6 Abs. 1 lit. b DSGVO.
          </p>

          <h2>Hosting und Server-Logfiles</h2>
          <p>
            Beim Besuch dieser Website können technisch notwendige Daten
            verarbeitet werden, z. B. IP-Adresse, Datum und Uhrzeit des Zugriffs,
            aufgerufene Seite, Browsertyp und Betriebssystem. Rechtsgrundlage ist
            Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h2>Google Fonts</h2>
          <p>
            Diese Website lädt Schriftarten über Google Fonts. Dabei kann Ihr
            Browser eine Verbindung zu Servern von Google herstellen, wobei Ihre
            IP-Adresse an Google übertragen werden kann. Rechtsgrundlage ist unser
            berechtigtes Interesse an einer einheitlichen Darstellung der Website
            gemäß Art. 6 Abs. 1 lit. f DSGVO.
          </p>

          <h2>Speicherdauer</h2>
          <p>
            Personenbezogene Daten werden nur so lange gespeichert, wie es für den
            jeweiligen Zweck erforderlich ist oder gesetzliche
            Aufbewahrungspflichten bestehen.
          </p>

          <h2>Ihre Rechte</h2>
          <p>Sie haben im Rahmen der gesetzlichen Vorgaben das Recht auf:</p>
          <ul>
            <li>Auskunft über die zu Ihrer Person gespeicherten Daten</li>
            <li>Berichtigung unrichtiger Daten</li>
            <li>Löschung oder Einschränkung der Verarbeitung</li>
            <li>Widerspruch gegen bestimmte Verarbeitungen</li>
            <li>Datenübertragbarkeit</li>
            <li>Widerruf erteilter Einwilligungen mit Wirkung für die Zukunft</li>
          </ul>

          <h2>Beschwerderecht</h2>
          <p>
            Sie haben das Recht, sich bei einer Datenschutzaufsichtsbehörde zu
            beschweren, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer
            personenbezogenen Daten gegen Datenschutzrecht verstößt.
          </p>
        </div>
      </section>
    </Layout>
  );
};

export default DatenschutzPage;
